import React, { Component } from "react";
import { passwordAlert } from "helpers";
import { Link, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import {
  ButtonCommonTheme,
  FormControl,
  FormGroup,
  Alert,
  LabelInputWithIcon,
} from "modules/theme";
import { AuthBox } from "../styles";
import APIManager from "modules/common/apiManager";
import { ControlLabel } from "modules/theme";
import OtpInput from "react-otp-input";
import { globalStateSelector } from "store/selector";
import { connect } from "react-redux";
import { localStore } from "helpers";

const propTypes = {
  socialLogin: PropTypes.func.isRequired,
};

class SocialLogin extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.state = {
      authData: {},
      isLoading: true,
    };
    this.loginUrl = "";
    this.verifyData = this.verifyData.bind(this);
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      let message = data && data.message ? data.message : "Done";
      Alert.success(message);
    } else {
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(message);
    }
  }

  verifyData(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    this.mAPI.sendPostAPI(
      `${this.loginUrl}/auth/${this.props.type}`,
      this.state.authData,
      (data) => {
        this.setState({ isLoading: false });
        try {
          localStore.setItem("token", data.token);
        } catch (e) {}
        if (data.role === 6) {
          this.props.history.push("/dial-pad");
        } else {
          this.props.history.push("/dashboard");
        }
        Alert.success(`Login Successful...`);
      },
      (error, data) => {
        this.setState({ isLoading: false });
        this.props.history.push("/sign-in");
        this.apiResponse(error, data);
      },
      `direct`
    );
  }

  // componentDidMount() {
  //   const tenant = localStorage.getItem("selected-tenant");

  //   if (this.props.accessUrl) {
  //     this.mAPI.updateUrl(this.props.accessUrl, tenant);
  //   } else {
  //     if (tenant) {
  //       this.mAPI.sendGetAPI(
  //         `company/new/${tenant}`,
  //         (data) => {
  //           if (data && data.accessUrl) {
  //             this.mAPI.updateUrl(data.accessUrl, tenant);
  //             this.loginUrl = `${data.accessUrl}/v1`;
  //           }
  //         },
  //         (error) => {
  //           Alert.error("Something went wrong.");
  //           this.props.history.push("/sign-in");
  //         },
  //         "public"
  //       );
  //     } else {
  //       this.props.history.push("/sign-in");
  //     }
  //   }

  //   const queryParams = new URLSearchParams(window.location.search);
  //   const code = queryParams.get("code");
  //   const clientInfo = queryParams.get("client_info");
  //   const state = queryParams.get("state");
  //   const sessionState = queryParams.get("session_state");

  //   if (code) {
  //     const data = {
  //       code,
  //       clientInfo,
  //       state,
  //       sessionState,
  //     };
  //     this.setState({ authData: data }, () => {
  //       if (this.state.authData) {
  //         this.verifyData();
  //       }
  //     });
  //   }
  // }

  componentDidMount() {
    const tenant = localStorage.getItem("selected-tenant");

    const setLoginUrlAndVerify = () => {
      const queryParams = new URLSearchParams(window.location.search);
      const code = queryParams.get("code");
      const clientInfo = queryParams.get("client_info");
      const state = queryParams.get("state");
      const sessionState = queryParams.get("session_state");
      const error = queryParams.get("error");

      if (code) {
        const data = {
          code,
          clientInfo,
          state,
          sessionState,
        };
        this.setState({ authData: data }, () => {
          if (this.state.authData && this.loginUrl) {
            this.verifyData();
          }
        });
      } else if (error) {
        Alert.error(error);
        this.props.history.push("/sign-in");
      }
    };

    if (this.props.accessUrl) {
      this.mAPI.updateUrl(this.props.accessUrl, tenant);
      this.loginUrl = `${this.props.accessUrl}/v1`;
      setLoginUrlAndVerify();
    } else if (tenant) {
      this.mAPI.sendGetAPI(
        `company/new/${tenant}`,
        (data) => {
          if (data && data.accessUrl) {
            this.mAPI.updateUrl(data.accessUrl, tenant);
            this.loginUrl = `${data.accessUrl}/v1`;
            setLoginUrlAndVerify();
          }
        },
        (error) => {
          Alert.error("Something went wrong.");
          this.props.history.push("/sign-in");
        },
        "public"
      );
    } else {
      this.props.history.push("/sign-in");
    }
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className="loading-content">
          <img
            src="/images/icons/loader-alt-alt.gif"
            alt="stream robot"
            style={{ filter: "invert() hue-rotate(90deg)" }}
          />
          <div>Please wait</div>
        </div>
      );
    }

    return <div>{/* Render content if authData is processed */}</div>;
  }
}

const stateToProps = (state) => ({
  accessUrl: globalStateSelector.getDynamic(state, {
    key: "accessUrl",
  }),
});

SocialLogin.propTypes = propTypes;
SocialLogin.contextTypes = {
  __: PropTypes.func,
};

export default withRouter(connect(stateToProps)(SocialLogin));



// WEBPACK FOOTER //
// src/modules/auth/components/SocialLogin.js